var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69905 12.4115C4.69905 13.4687 3.83536 14.3324 2.7782 14.3324C1.72107 14.3324 0.857422 13.4687 0.857422 12.4115C0.857422 11.3544 1.72111 10.4907 2.7782 10.4907H4.69905V12.4115Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 12.4115C5.66797 11.3544 6.5317 10.4907 7.58882 10.4907C8.64595 10.4907 9.50964 11.3544 9.50964 12.4115V17.2214C9.50964 18.2785 8.64591 19.1421 7.58882 19.1421C6.53166 19.1421 5.66797 18.2784 5.66797 17.2214V12.4115Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58882 4.69885C6.53166 4.69885 5.66797 3.83512 5.66797 2.77799C5.66797 1.72087 6.5317 0.857178 7.58882 0.857178C8.64595 0.857178 9.50964 1.72091 9.50964 2.77799V4.69885H7.58882Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58803 5.66675C8.64515 5.66675 9.50885 6.53044 9.50885 7.5876C9.50885 8.64473 8.64512 9.50834 7.58803 9.50834H2.7782C1.72107 9.50834 0.857422 8.64469 0.857422 7.5876C0.857422 6.5304 1.72111 5.66675 2.7782 5.66675H7.58803Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3008 7.5876C15.3008 6.5304 16.1644 5.66675 17.2216 5.66675C18.2787 5.66675 19.1423 6.53044 19.1423 7.5876C19.1423 8.64473 18.2787 9.50834 17.2216 9.50834H15.3008V7.5876Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3319 7.58787C14.3319 8.64499 13.4682 9.5086 12.4111 9.5086C11.3539 9.5086 10.4902 8.64495 10.4902 7.58787V2.77799C10.4902 1.72087 11.354 0.857178 12.4111 0.857178C13.4682 0.857178 14.3319 1.72091 14.3319 2.77799V7.58787Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4111 15.3015C13.4682 15.3015 14.3319 16.1652 14.3319 17.2224C14.3319 18.2795 13.4682 19.1431 12.4111 19.1431C11.3539 19.1431 10.4902 18.2794 10.4902 17.2224V15.3015H12.4111Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4111 14.3324C11.3539 14.3324 10.4902 13.4687 10.4902 12.4115C10.4902 11.3544 11.354 10.4907 12.4111 10.4907H17.2209C18.278 10.4907 19.1417 11.3544 19.1417 12.4115C19.1417 13.4687 18.278 14.3324 17.2209 14.3324H12.4111Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/slack-icon.26dce09a6314d9fdbb73f94b11cad10c.svg";
export { ForwardRef as ReactComponent };